import { WorkoutLogEntry } from "../models/Workout";

export const WORKOUT_LOG_LOCAL_STORAGE_KEY = 'workoutLogEntries';

export function removeWorkoutLogEntry(workoutLogEntries: WorkoutLogEntry[], id: string) {
  return workoutLogEntries.filter(entry => entry.id !== id)
}
